import { handleActions } from 'redux-actions'
import { Record, Map } from 'immutable'
import { REHYDRATE } from 'redux-persist'

import { companyStatsRequest } from './actions'
import { ICompanyStats } from './interface'

export const CompanyStats = Record<ICompanyStats>(
  {
    pending: false,
    data: Map(),
  } as ICompanyStats,
  'CompanyStats'
)

const handleRehydrate = (state: any, { payload }: any) => {
  if (payload && payload.companyStats && payload.companyStats.set) {
    return payload.companyStats.set('data', Map(payload.companyStats.get('data')))
  }
  return state
}

const fetchCompanyStatsRequest = (state: any) => {
  return state.set('pending', true)
}

const fetchCompanyStatsSuccess = (state: any, { payload: { data } }: any) => {
  return state.set('data', Map(data)).set('pending', false)
}

const fetchCompanyStatsFail = (state: any) => {
  return state.set('pending', false)
}

export default handleActions(
  {
    [REHYDRATE]: handleRehydrate,
    [companyStatsRequest as any]: fetchCompanyStatsRequest,
    [companyStatsRequest.success as any]: fetchCompanyStatsSuccess,
    [companyStatsRequest.fail as any]: fetchCompanyStatsFail,
  } as any,
  new CompanyStats()
)
